var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-detail"},[_c('div',{staticClass:"detail-container"},[_c('div',{staticClass:"article-content"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }